import { z } from "zod";

export const birthingFlowsheetFormSchema = z.object({
  birthingDate: z.date().nullable(),
  birthingTime: z.string().nullable(),
  birthingCrownDateTime: z.date().nullable().optional(),
  birthingHeadDateTime: z.date().nullable().optional(),
  birthingBodyDateTime: z.date().nullable().optional(),
  birthingType: z.string().nullable().optional(),
  birthingPosition: z.string().nullable().optional(),
  birthingInWater: z.string().nullable().optional(),
  birthingInWaterOther: z.string().optional(),
  birthingFetalPresentation: z.string().nullable().optional(),
  birthingDeliveryMethod: z.string().nullable().optional(),
  birthingDeliveryMethodOther: z.string().optional(),
  birthingNotes: z.string().optional(),
  birthingSignatureInitials: z.array(z.string()).optional(),
});

export type BirthingFlowsheetFormSchemaType = z.infer<typeof birthingFlowsheetFormSchema>;
